export default __webpack_public_path__ + "cf0e4d96a0bfd105e2532ad72e53fdda.png";